import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Person, BoxArrowRight } from 'react-bootstrap-icons';

import localStorageService from '../../../../../services/localStorage.service';
import ReleaseService from '../../../../../services/release.service';

import "./styles.scss";

const ProfileArea = (props) => {
    const [username, setUsername] = useState("");
    const [version, setVersion] = useState(null);

    useEffect(() => {
        const userData = localStorageService.getUserData();
        setUsername(userData?.full_name);

        // The version is a nice-to-have, so a failed request just hides it.
        ReleaseService.getStatus()
            .then((status) => setVersion(status.latest_version))
            .catch(() => setVersion(null));
    }, []);

    return (
        <div className="sidebar-profile-container">
            <div className="sidebar-profile-area title-sliding">
                <div className="sidebar-profile-name">
                    <div>
                        <div>Welcome,</div>
                        <div className="sidebar-profile-name-text">{username}!</div>
                        {version && (
                            <Link to="/release_notes" className="sidebar-profile-version" title="Release notes">
                                Version {version}
                            </Link>
                        )}
                    </div>
                    <Link to="/logout" className="sidebar-profile-logout" title='Logout'>
                        <BoxArrowRight size={20} />
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ProfileArea;